import { format } from "date-fns";
import useAsyncFunction from "../../hooks/useAsyncFunction"
import BasicTable from "../common/BasicTable";
import Table from "../common/table";
import apiCondensadores from "../../services/apis/apiCondensadores";

export default function CondensadorTable({ equipamento }) {
        
    const { data, loading, error } = useAsyncFunction(async () => await apiCondensadores.getEquipamentoComUltimasLeituras(equipamento.id, 50)) || [];

    if (loading) return <p>Carregando...</p>;

    if(!data || error) {
        return null
    }
        

    const leituras = data?.leiturasCondensadores || [];

    
    return <BasicTable 
        headerContent={["LEITURA ID", "LIGADO", "DATA HORA", "T. ENTRADA", "T. SAÍDA", "UMIDADE RELATIVA ENTRADA", "UMIDADE RELATIVA SAÍDA", "VELOCIDADE AR ENTRADA"]} 
    >   
        {
            leituras.map((leitura) => (
            <Table.Row key={leitura.id}>
                <Table.Data>{leitura.id}</Table.Data>
                <Table.Data>{leitura.ligado ? "on" : "off"}</Table.Data>
                <Table.Data>{format(leitura.dataHora, "dd/MM/yyyy HH:mm:ss")}</Table.Data>
                <Table.Data>{leitura.temperaturaEntrada}</Table.Data>
                <Table.Data>{leitura.temperaturaSaida}</Table.Data>
                <Table.Data>{leitura.umidadeRelativaEntrada}</Table.Data>
                <Table.Data>{leitura.umidadeRelativaSaida}</Table.Data>
                <Table.Data>{leitura.velocidadeArEntrada}</Table.Data>
            </Table.Row>
            ))
        }
    </BasicTable>

}